import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('view');
const type = createActionType('view');

export const GET_VIEW = apiType('GetView');
export const EDIT_VIEW = type('EditView');
